var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.392 16.6819L23.4374 20.7273C24.1838 21.4766 24.1838 22.6882 23.4374 23.4375C22.6819 24.1729 21.4781 24.1729 20.7226 23.4375L16.6771 19.3921C12.3664 22.2986 6.55266 21.4536 3.24769 17.4402C-0.0572733 13.4265 0.228718 7.55884 3.90832 3.88574C7.58793 0.212646 13.4562 -0.0629883 17.4639 3.24902C21.4716 6.56104 22.3063 12.3762 19.392 16.6819ZM19.2 11.0447C19.2 6.53809 15.5466 2.88477 11.04 2.88477C6.53555 2.89014 2.88529 6.54028 2.88 11.0447C2.88 15.5515 6.53336 19.2048 11.04 19.2048C15.5466 19.2048 19.2 15.5515 19.2 11.0447Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68 12.0049H10.08V14.4049C10.08 14.935 10.5098 15.3649 11.04 15.3649C11.5702 15.3649 12 14.935 12 14.4049V12.0049H14.4C14.9302 12.0049 15.36 11.575 15.36 11.0449C15.36 10.5147 14.9302 10.0849 14.4 10.0849H12V7.68485C12 7.15466 11.5702 6.72485 11.04 6.72485C10.5098 6.72485 10.08 7.15466 10.08 7.68485V10.0849H7.68C7.14981 10.0849 6.72 10.5147 6.72 11.0449C6.72 11.575 7.14981 12.0049 7.68 12.0049Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoomIn.d0fa1ef9.svg";
export { ForwardRef as ReactComponent };